import React from 'react'
import {connect} from 'react-redux';
import ActivityWorker from './ActivityWorker';
import {toggleActivityListFilter} from './ActivityList-Actions'
import ActivityHeading from "./ActivityHeading";
import store from '../../../Store';
import TableHead from "../../../components/shared/table/TableHead";
import Page from "../../../components/shared/pages/Page";
import PaginationButtons from "../../../components/shared/buttons/PaginationButtons";
import {setDashboardMenu} from "../../../routes/main-route/MainRoute-Actions";
import {fullDate} from "../../../helpers/DateTimeHelper";
import Loading from "../../../components/shared/loaders/Loading";
import OrganizationSideMenu from '../../organization/OrganizationSideMenu';
import {ActivityLogStatus} from '../../../components/shared/status/Status';

class Activity extends React.Component {

    componentDidMount() {
        document.querySelector('body').classList.add('organization-dashboard');
        store.dispatch(setDashboardMenu('organization'));
    }

    componentWillUnmount() {
        document.querySelector('body').classList.remove('organization-dashboard');
    }

    toggleSort = (field) => {
        store.dispatch(toggleActivityListFilter({
            target: {name: `sort_by`, value: field}
        }))
    };

    render() {
        let {pages, getActivity, list, params, fields} = this.props;

        let {processing, error} = getActivity;
        if (error) {
            this.props.history.push('/');
        }

        return (
            <Page title="Activity Log">
                <div className="page-content">

                    <div className="organizations-sidebar">
                        <OrganizationSideMenu processing={processing}/>
                    </div>
                    <div className="content-section">
                        <ActivityHeading organization_id={this.props.match.params.id}/>
                        <div className="table-block table-responsive pr-60">
                            <table className="table table-striped mb-60 table-with-action-dropdown">
                                <TableHead fields={fields}
                                           params={params}
                                           noActions={true}
                                           onClick={this.toggleSort}/>
                                <tbody>
                                {processing ? <td colSpan={5} className="text-center"><Loading/></td> :

                                    list && list.length ? list.map((l, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td>{fullDate(l.created_at)}</td>
                                                    <td>
                                                        {
                                                            l.user_name && true ?
                                                                l.user_name : "Celestio"
                                                        }
                                                    </td>
                                                    <td>{l.site_name || "-"}</td>
                                                    {l.description ?
                                                        <td className="action-td">
                                                            <div className="collapse-link">
                                                                {l.payment ?
                                                                    <>   {l.event} {"("}{l.payment.amount} {l.payment.currency}{")"}
                                                                    </> :
                                                                    l.event}
                                                            </div>
                                                            <div className="collapse-content">
                                                                {l.description}
                                                            </div>
                                                        </td> :
                                                        <td>{l.payment ?
                                                            <>   {l.event} {"("}{l.payment.amount} {l.payment.currency}{")"}
                                                            </> :
                                                            l.event}
                                                        </td>
                                                    }

                                                    {/*{l.payment ?*/}
                                                    {/*<td>{l.event} {"("}{l.payment.amount} {l.payment.currency}{")"}</td>:*/}
                                                    {/*<td>{l.event}</td>}*/}


                                                    <td className="last-item">
                                                        <ActivityLogStatus status={l.status}/>
                                                        {/*<i className={`icon-${l.status === "failed" ? "close-circle" : 'checkmark'} text-${l.status === "failed" ? "danger" : l.status === "pending" ? "primary" : "success"}`}/>*/}

                                                    </td>
                                                </tr>
                                            )
                                        }) :
                                        <tr>
                                            <td colSpan="5" className="text-center">No Activity Logs
                                                Available
                                            </td>
                                        </tr>
                                }
                                    </tbody>
                                    </table>
                                    </div>
                                {list && list.length ? (
                                    <div className="fixed-footer pr-60" id="inside-organization-pagination">
                                    <PaginationButtons pages={pages}
                                    processing={processing}
                                    fetchAction={toggleActivityListFilter}/>
                                    </div>
                                    ) : null}
                                    </div>

                                    </div>
                                    <ActivityWorker/>
                                    </Page>
                                    )
                                }
}

function mapStateToProps(state) {
    let {userDetail, activityList, getActivity, getOrganization, getLoggedInUser} = state;

    let {params, fields, modal} = activityList.data;

    let {success} = getActivity;

    let list =
        success &&
        success.data &&
        success.data.data.data;

    let org_id = getOrganization.success?.id
    let logged_in_user_id = getLoggedInUser.success?.data.data.id


    let current_page = success && success.data && success.data.data.current_page;
    let last_page = success && success.data && success.data.data.last_page;
    let total = success && success.data && success.data.data.total;
    let from = success && success.data && success.data.data.from;
    let pages = {current_page, last_page, total, from};

    return {getActivity, list, userDetail, activityList, pages, params, fields, modal, org_id, logged_in_user_id};
}

export default connect(mapStateToProps)(Activity);